import React, { useEffect, useState } from 'react'
import Cookies from "js-cookie";
import './MyCourse.css'
import Content from '../Content/Content'
import { getUserInfo } from '../auth/helper';
import { useNavigate } from 'react-router-dom';

const MyCourse = () => {
    const [userName, setUserName] = useState(null);
    const navigate = useNavigate();
    const [totalGiftTokens, setTotalGiftTokens] = useState(null);

    useEffect(() => {
      const token = Cookies.get("token");
      if (token) {
          getUserInfo(token).then((data) => {
              if (data && data.name) {
                  setUserName(data.name);
                  setTotalGiftTokens(data.total_gift_tokens)
              }
          });
      }
  }, []);

    useEffect(() => {
        const token = Cookies.get("token");
        if (!token) {
            navigate('/');
        }
    }, []);
  return (
        <>
            <div className='mycourse-container'>
                <div className='margin-top-mycourse'></div>
                <div className='mycourse-main'>
                    <div className='mycourse-left'>
                        <div className='balance-div'>
                            <p className='balance-title'>موجودی حساب شما</p>
                            <svg className='balance-svg' viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.87868 0.87868C0 1.75736 0 3.17157 0 6V12C0 14.8284 0 16.2426 0.87868 17.1213C1.75736 18 3.17157 18 6 18H16C16.93 18 17.395 18 17.7765 17.8978C18.8117 17.6204 19.6204 16.8117 19.8978 15.7765C20 15.395 20 14.93 20 14H14C12.3431 14 11 12.6569 11 11C11 9.34315 12.3431 8 14 8H20V6C20 3.17157 20 1.75736 19.1213 0.87868C18.2426 0 16.8284 0 14 0H6C3.17157 0 1.75736 0 0.87868 0.87868ZM5 4C4.44772 4 4 4.44772 4 5C4 5.55228 4.44772 6 5 6H8C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4H5Z" fill="#E53B1F" />
                            </svg>
                        </div>
                        <div className='mycourse-horizontal-line'></div>
                        <div className='mycourse-token'>
                            <div className='mycourse-logo-container'>
                                <img src={require("../images/EEVA_LOGO.png")} alt="EEVA_LOGO" className='mycourse-logo' />
                            </div>
                            <p className='mycourse-token-title'>{totalGiftTokens} توکن ایوا</p>
                        </div>
                    </div>
                    <div className='mycourse-right'>
                        <p className='welcome-title'>{userName} عزیز؛ به آکادمی ایوا خوش اومدی!</p>
                    </div>
                </div>
                <div className='mycourse-horizontal-line1'></div>
                <Content fromMyCourse={true}/>
            </div>

            <div className='mycourse-container-mobile'>
                <div className='margin-top-mycourse-mobile'></div>
                <p className='welcome-title-mobile'>{userName} عزیز؛ به آکادمی ایوا خوش اومدی!</p>
                <div className='balance-div-mobile'>
                    <p className='balance-title-mobile'>موجودی حساب شما</p>
                    <svg className='balance-svg-mobile' viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.87868 0.87868C0 1.75736 0 3.17157 0 6V12C0 14.8284 0 16.2426 0.87868 17.1213C1.75736 18 3.17157 18 6 18H16C16.93 18 17.395 18 17.7765 17.8978C18.8117 17.6204 19.6204 16.8117 19.8978 15.7765C20 15.395 20 14.93 20 14H14C12.3431 14 11 12.6569 11 11C11 9.34315 12.3431 8 14 8H20V6C20 3.17157 20 1.75736 19.1213 0.87868C18.2426 0 16.8284 0 14 0H6C3.17157 0 1.75736 0 0.87868 0.87868ZM5 4C4.44772 4 4 4.44772 4 5C4 5.55228 4.44772 6 5 6H8C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4H5Z" fill="#E53B1F" />
                    </svg>
                </div>
                <div className='mycourse-token-mobile'>
                    <div className='mycourse-logo-container-mobile'>
                        <img src={require("../images/EEVA_LOGO.png")} alt="EEVA_LOGO" className='mycourse-logo' />
                    </div>
                    <p className='mycourse-token-title-mobile'>{totalGiftTokens} توکن ایوا</p>
                </div>
                <div className='mycourse-horizontal-line1-mobile'></div>
                <Content fromMyCourse={true}/>
            </div>
        </>
  )
}

export default MyCourse